module.exports = __webpack_public_path__ + "static/media/image_96.4dff4459.png";